import React from 'react';
import {FormattedMessage} from 'react-intl';
import {usePopupEditPaidContext} from './PopupEditPaidContext';
import {formatStringToFloatNumber} from '../../../_common/utils/changeInputValue';
import {StyledFieldInput} from '../../../_common/components/FieldInput';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContent from '../../../_common/components/ModalContent';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';

const PopupEditPaidForm = () => {
  const {formik, handleEdit, handleCloseModal} = usePopupEditPaidContext();

  return (
    <>
      <ModalContent customClassnames={'bg-transparent'}>
        <StyledFieldInput
          fieldId={'paid'}
          value={formik.values.paid}
          onChange={(e) => formik.setFieldValue('paid', formatStringToFloatNumber(e))}
          label={<FormattedMessage id="orders-page-column-paid" defaultMessage="Paid"/>}
        />
      </ModalContent>
      <ModalButtonsContainer customClassnames={largeButtonsPadding}>
        <ButtonAction
          variant={'cancel'}
          onClick={handleCloseModal}
          label={<FormattedMessage id="button-cancel" defaultMessage="Cancel"/>}
          customClassnames={buttonCancel}
        />
        <ButtonAction
          onClick={handleEdit}
          disabled={!formik.dirty}
          useIcon={'/media/common/Check-in-circle_white.svg'}
          label={<FormattedMessage id="button-submit" defaultMessage="Edit"/>}
          customClassnames={buttonSubmit}
        />
      </ModalButtonsContainer>
    </>
  );
};

export default PopupEditPaidForm;